export const quizData = [
    {
        question: "What is the name of Harry Potter's pet owl?",
        options: ["Hedwig", "Scabbers", "Crookshanks", "Fawkes"],
        answer: 0
    },
    {
        question: "Who is the Half-Blood Prince?",
        options: ["Albus Dumbledore", "Severus Snape", "Tom Riddle", "Sirius Black"],
        answer: 1
    },
    {
        question: "What is the name of Harry's father?",
        options: ["James", "Sirius", "Remus", "Peter"],
        answer: 0
    },
    {
        question: "Who is the headmaster of Hogwarts School of Witchcraft and Wizardry in the first book?",
        options: ["Professor McGonagall", "Professor Snape", "Professor Dumbledore", "Professor Flitwick"],
        answer: 2
    },
    {
        question: "What is the name of the magical sport played on broomsticks?",
        options: ["Quidditch", "Wizardball", "Broomstick Ball", "Witchball"],
        answer: 0
    },
    {
        question: "What is the name of the street where the Dursleys live?",
        options: ["Privet Drive", "Number 4, Grimmauld Place", "Godric's Hollow", "Diagon Alley"],
        answer: 0
    },
    {
        question: "What is the name of the train that takes students to Hogwarts?",
        options: ["The Knight Bus", "The Hogwarts Express", "The Flying Ford Anglia", "Thestrals"],
        answer: 1
    },
    {
        question: "What type of creature is Dobby?",
        options: ["Elf", "Goblin", "Giant", "House-Elf"],
        answer: 3
    },
    {
        question: "What is the name of Hagrid's three-headed dog?",
        options: ["Fluffy", "Fang", "Norbert", "Aragog"],
        answer: 0
    },
    {
        question: "What is the name of the prison guarded by Dementors?",
        options: ["Azkaban", "Diagon Alley", "Hogsmeade", "Borgin and Burkes"],
        answer: 0
    },
    {
      question: "What position does Harry Potter play in Quidditch?",
      options: ["Seeker", "Chaser", "Keeper", "Beater"],
      answer: 0
    },
    {
      question: "Which house does the Sorting Hat almost place Harry in before deciding on Gryffindor?",
      options: ["Ravenclaw", "Slytherin", "He doesn't almost get sorted into another house", "Hufflepuff"],
      answer: 2
    },
    {
      question: "What is the name of the Weasley family's house?",
      options: ["The Burrow", "The Manor", "The Hollow", "Godric's Hollow"],
      answer: 0
    },
    {
      question: "What is the name of Harry Potter's best friends?",
      options: ["Luna Lovegood and Ginny Weasley", "Draco Malfoy and Neville Longbottom", "Cho Chang and Cedric Diggory", "Hermione Granger and Ron Weasley"],
      answer: 3
    },
    {
      question: "Who is the Potions Master at Hogwarts?",
      options: ["Severus Snape", "Horace Slughorn", "Gilderoy Lockhart", "Dolores Umbridge"],
      answer: 0
    },
    {
        question: "What is the name of Hermione Granger's cat?",
        options: ["Crookshanks", "Mrs. Norris", "Trevor", "Fang"],
        answer: 0
    },  
    {
        question: "What is the name of the house-elf who serves the Black family?",
        options: ["Kreacher", "Dobby", "Winky", "Hokey"],
        answer: 0
    },
    {
        question: "Who is the founder of the Slug Club?",
        options: ["Horace Slughorn", "Albus Dumbledore", "Gilderoy Lockhart", "Severus Snape"],
        answer: 0
    },
    {
        question: "What is the name of the Weasley family's flying car?",
        options: ["The Flying Ford Anglia", "The Knight Bus", "Thestral", "The Bluebell Flames"],
        answer: 0
    },
    {
        question: "Who is the captain of the Slytherin Quidditch team during Harry's first year at Hogwarts?",
        options: ["Marcus Flint", "Draco Malfoy", "Adrian Pucey", "Millicent Bulstrode"],
        answer: 0
    },
    {
        question: "What is the name of the spell that creates a protective barrier against Dementors?",
        options: ["Expecto Patronum", "Expelliarmus", "Lumos", "Stupefy"],
        answer: 0
    },
    {
        question: "Who is the ghost of Ravenclaw House at Hogwarts?",
        options: ["The Grey Lady", "The Bloody Baron", "Nearly Headless Nick", "Moaning Myrtle"],
        answer: 0
    }, 
    {
        question: "What is the name of the village near Hogwarts where Hagrid lives?",
        options: ["Hogsmeade", "Godric's Hollow", "Little Whinging", "Ottery St. Catchpole"],
        answer: 0
    },
    {
        question: "What is the name of the shop in Diagon Alley where Harry buys his wand?",
        options: ["Ollivanders", "Madam Malkin's Robes for All Occasions", "Flourish and Blotts", "Quality Quidditch Supplies"],
        answer: 0
    }
  ];
 

